import { Artist } from '@favid-inc/api';
import { Action } from 'core/generic';
import { SubAccount } from 'features/iugo';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { EmptyList, Loading } from 'utils/GenericCompoents';
import { artistDetailsReducer, ArtistOrders, fetchArtist } from './';
import { ArtistCard } from './ArtistCard';
import { ArtistForm } from './ArtistForm';
export interface ArtistDetailsState {
  artist?: Artist;
  isLoading: boolean;
  errorMessage?: string;
  isShowingModalIugo: boolean;
}

const initialState: ArtistDetailsState = {
  isLoading: true,
  isShowingModalIugo: false,
};

class ArtistDetailsCompontent extends React.Component<
  RouteComponentProps<{ id: string }>
> {
  state = initialState;

  componentDidMount() {
    const artistId: Artist['id'] = Number(this.props.match.params.id);
    fetchArtist(artistId, this.dispatch);
  }

  dispatch = (action: Action) => {
    this.setState(() => artistDetailsReducer(this.state, action));
  };

  onOpenModalIugo = () => {
    this.setState({ isShowingModalIugo: true });
  };

  onCloseModalIugo = () => {
    this.setState({ isShowingModalIugo: false });
  };

  render() {
    const { artist, isLoading, isShowingModalIugo, errorMessage } = this.state;
    if (isLoading) {
      return <Loading />;
    }

    if (errorMessage) {
      return <EmptyList message={errorMessage} />;
    }

    if (!artist) {
      return;
    }

    if (isShowingModalIugo) {
      return <SubAccount artist={artist} onClose={this.onCloseModalIugo} />;
    }

    return (
      <div>
        <div className='ui segment'>
          <ArtistCard
            artist={artist}
            dispatch={this.dispatch}
            onOpenModalIugo={this.onOpenModalIugo}
          />
          <ArtistForm artist={artist} dispatch={this.dispatch} />
        </div>
        <ArtistOrders artist={artist} />
      </div>
    );
  }
}

export const ArtistDetails = withRouter(
  ArtistDetailsCompontent,
) as React.ComponentClass<{}>;
